import { useTranslation } from 'react-i18next';

export default function PhilosophySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-3">
              <div className="w-8 h-px bg-[#7B1113]" />
              <span className="text-[11px] tracking-[0.2em] uppercase text-[#7B1113] font-medium">{t('threeStep.philosophy.label')}</span>
            </div>

            <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-[#2A2A2A] leading-[1.15]">{t('threeStep.philosophy.heading')}</h2>

            <div className="flex flex-col gap-4">
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                {t('threeStep.philosophy.p1')}
              </p>
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                <strong className="text-[#2A2A2A] font-medium">{t('threeStep.philosophy.prep')}</strong> — {t('threeStep.philosophy.prepDesc')}
              </p>
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                <strong className="text-[#2A2A2A] font-medium">{t('threeStep.philosophy.treat')}</strong> — {t('threeStep.philosophy.treatDesc')}
              </p>
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                <strong className="text-[#2A2A2A] font-medium">{t('threeStep.philosophy.seal')}</strong> — {t('threeStep.philosophy.sealDesc')}
              </p>
              <p className="text-sm text-[#8A8A8A] font-light leading-[1.9]">
                {t('threeStep.philosophy.p2')}
              </p>
            </div>
          </div>

          <div className="flex flex-col items-center gap-6 w-full max-w-sm mx-auto">
            <div className="flex flex-col items-center gap-3 w-full">
              <div className="flex items-center gap-3 px-4 md:px-6 py-4 rounded-xl bg-[#1B3A5C]/10 border border-[#1B3A5C]/20 w-full justify-center">
                <span className="w-8 h-8 rounded-full bg-[#1B3A5C] text-white text-xs font-bold flex items-center justify-center flex-shrink-0">01</span>
                <span className="text-xs md:text-sm font-medium text-[#1B3A5C]">OPEN — {t('threeStep.philosophy.prep')}</span>
              </div>

              <div className="w-px h-6 bg-[#8A8A8A]/20" />

              <div className="flex items-center gap-3 px-4 md:px-6 py-4 rounded-xl bg-[#7B1113]/10 border border-[#7B1113]/20 w-full justify-center">
                <span className="w-8 h-8 rounded-full bg-[#7B1113] text-white text-xs font-bold flex items-center justify-center flex-shrink-0">02</span>
                <span className="text-xs md:text-sm font-medium text-[#7B1113]">TREAT — {t('threeStep.philosophy.treat')}</span>
              </div>

              <div className="w-px h-6 bg-[#8A8A8A]/20" />

              <div className="flex items-center gap-3 px-4 md:px-6 py-4 rounded-xl bg-[#2D6A4F]/10 border border-[#2D6A4F]/20 w-full justify-center">
                <span className="w-8 h-8 rounded-full bg-[#2D6A4F] text-white text-xs font-bold flex items-center justify-center flex-shrink-0">03</span>
                <span className="text-xs md:text-sm font-medium text-[#2D6A4F]">LOCK — {t('threeStep.philosophy.seal')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}